import { TextTooltip } from '~/@mid_ui/text-tooltip/TextTooltip'

const tooltipByType = {
  accountValue: (
    <TextTooltip text="Súčet vašich rezervovaných, investovaných prostriedkov a očakávaných výnosov" />
  ),
  disponibleFunds: (
    <TextTooltip text="Suma vašich voľných prostriedkov, ktoré je možné investovať" />
  ),
  reservedFunds: (
    <TextTooltip text="Suma vami rezervovaných prostriedkov do otvorených investičných príležitostí. Po uzavretí kampane budú automaticky zainvestované" />
  ),
  investedFunds: (
    <TextTooltip text="Suma vami investovaných prostriedkov do projektov" />
  ),
  expectedFutureRevenue: (
    <TextTooltip text="Súčet očakávaných výnosov a bonusov, ktoré vám budú vyplatené po ukončení všetkých projektov, do ktorých ste investovali" />
  ),
}

export { tooltipByType }
